import { logoutState } from "./atom";

export default {
  logoutState,
};
